import React from 'react';
import Type from 'prop-types';
import { Box, Chip } from "@mui/material";
import styles from './DateSeparator.module.css';

const DateSeparator = (props) => {
  const { date: dateProp, formatDate } = props;
  const rawDate = new Date(dateProp);
  const { date } = formatDate(rawDate);

  return (
    <Box my={2} className={styles.root}>
      <Chip label={date} variant="outlined" color="primary" />
    </Box>
  );
};

DateSeparator.propTypes = {
  date: Type.string.isRequired,
  formatDate: Type.func.isRequired,
};

export default DateSeparator;
